module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/mv_sp-bf40bb8cd9f1e0393fb7f1030f24edca.png";